module.exports = __webpack_public_path__ + "img/Icon_History_Proposal_Hover.8e194146.svg";